module.exports = __webpack_public_path__ + "static/media/health-shape.aa1f4280.svg";